import type { AllRouteEndpoints } from "../routeTypes";
export const appsUserInfoUserIdentifierCancelSingleUserDeletionCacheKeys: AllRouteEndpoints[] = [];
